import React from 'react'
import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'

import Footer from '../Footer'
import Header from '../Header'

function UnauthorizedLayout() {
   return (
      <Box sx={{ display: 'flex', height: '100vh', flexDirection: 'column' }}>
         <Header />
         <Box
            component="main"
            sx={{ flex: 1, flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'auto' }}
         >
            <Outlet />
         </Box>
         <Footer />
      </Box>
   )
}

export default UnauthorizedLayout
